import React from 'react';

import styles from './styles.module.css';

export const FlixLogoMark = () => (
	<svg className={styles.buddyIconSvg} viewBox="0 0 32 32" fill="none" aria-hidden="true">
		<path
			d="M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4z"
			fill="currentColor"
			opacity="0.18"
		/>
		<path d="M10 16h12M16 10v12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
	</svg>
);

export const SendIcon = () => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<line x1="22" y1="2" x2="11" y2="13" />
		<polygon points="22 2 15 22 11 13 2 9 22 2" />
	</svg>
);

export const ExpandIcon = () => (
	<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<polyline points="3 10 3 13 6 13" />
		<polyline points="13 6 13 3 10 3" />
		<line x1="3" y1="13" x2="7.5" y2="8.5" />
		<line x1="8.5" y1="7.5" x2="13" y2="3" />
	</svg>
);
